import CustomButton from '../../../../features/customButton/ui/main/CustomButton';
import { useClickOnQuestButton } from '../../../../../hooks/shared/quests/useClickOnQuestButton';
import { useTranslation } from '../../../../../translations';
import content from '../../constants/content';

const { getReward } = content;

export default function ChallengeSectionButton({ challengeData, callbacks }) {
  const { t } = useTranslation();

  const clickOnQuest = useClickOnQuestButton({ quest: challengeData, callbacks });

  return <CustomButton {...getReward} text={t('other.collect')} onClick={clickOnQuest} />;
}
